import type { Question, QuestionStimulus, QuestionType } from '@examflow/core';

/**
 * JLPT 考试等级 (N5 初级 -> N1 高级)
 */
export enum JLPTLevel {
  N5 = 'N5',
  N4 = 'N4',
  N3 = 'N3',
  N2 = 'N2',
  N1 = 'N1',
}

/**
 * JLPT 考试部分
 */
export enum JLPTSection {
  /** 语言知识（文字·词汇） */
  VOCABULARY = 'vocabulary',
  /** 语言知识（语法）·阅读 */
  GRAMMAR_READING = 'grammar_reading',
  /** 听力 */
  LISTENING = 'listening',
}

/**
 * JLPT 题目扩展接口
 */
export interface JLPTQuestion extends Question {
  /** 对应的 JLPT 等级 */
  jlptLevel?: JLPTLevel;
  /** 所属考试部分 */
  section?: JLPTSection;
  /** 题目序号（在该部分中） */
  orderInSection?: number;
}

/**
 * JLPT 听力题目（single_choice + audio stimulus）
 */
export interface JLPTListeningQuestion extends JLPTQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'audio'>[];
  /** 音频URL */
  audioUrl: string;
  /** 音频播放次数限制 */
  maxPlayCount?: number;
  /** 音频时长（秒） */
  audioDuration?: number;
}

/**
 * JLPT 阅读题目（single_choice + passage stimulus）
 */
export interface JLPTReadingQuestion extends JLPTQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'passage'>[];
  /** 阅读材料 */
  passage: string;
  /** 材料来源 */
  source?: string;
}

/**
 * JLPT 分数与等级对照表
 */
export interface JLPTScoreMapping {
  level: JLPTLevel;
  minScore: number;
  maxScore: number;
  passingScore: number;
  description: string;
}

/**
 * JLPT 考试结果
 */
export interface JLPTResult {
  /** 总分 */
  totalScore: number;
  /** 等级 */
  level: JLPTLevel;
  /** 各部分得分 */
  sectionScores: Record<JLPTSection, number>;
  /** 及格 */
  passed: boolean;
  /** 详细评价 */
  evaluation: string;
}
